<template>
  <main>
    <h1 class="text-green">{{this.dat.Title}}</h1>
    <form v-if="ExistenAprobaciones">
      <div class="form-footer">
        <div class="center">
          <div style="
              position: static;
              width: 100% !important;
              height: 6em !important;
              margin: auto;
              background-color: #ffffffa3;">
            <div class="center" style="
              width: 70% !important;
              height: 18em !important;
              margin: auto;
              background-color: #ffffffa3;
              border:solid;
              border-style:ridge;
              border-color:lightgray;
              text-align:left !important;
              padding: 10px;
              word-wrap: break-word;">

              <span v-html="StrHtml"></span>
              <h6 v-if="VisibleTyC">He leído y acepto los
                <a href="#" @click.prevent="descargarArchivo(VersionTyC)"><strong style="color: #007a5e;">Términos y Condiciones</strong></a>
              </h6>
              <h6 v-if="VisibleTDP">He leído y autorizo el
                <a href="#" @click.prevent="descargarArchivo(VersionTDP)"><strong style="color: #007a5e;">Tratamiento de Datos Personales</strong></a>
              </h6>

              <br/><br/>
            </div>                      
            <Btn action="submit(true)"
                type="green"
                style="display:inline-block"
                @click.prevent="submit(true)">{{Submit}}
            </Btn>
          </div>
        </div>           
      </div>
    </form>
    <Spinner v-if="loading" type="modern"></Spinner>
  </main>
</template>
  
  <script>
  import api from "../api/TyC";
  import Btn from "../components/UIElements/Btn";
  import Spinner from "../components/UIElements/Spinner";

  export default {
    name: "FormReport",
    components: { Btn, Spinner },
    data() {
      return {
        emptyData: true,
          loading: true,          
          VersionTyC: "",
          VersionTDP: "",
          VisibleTyC: true,
          VisibleTDP: true,
          ExistenAprobaciones: true,
          StrHtml: "",
        dat: {
          Title: "Aprobación de Términos y Condiciones y Autorización de Tratamiento de Datos Personales",
          Inputs: [],
          FileName: "",
          Data: {}
        },
          Submit: "Aprobar",
        token: {},
        id: ""
        };
    },
          async created() {
              this.loading = true;
              var id = this.$route.params.id;
              await this.getData(id);
    },
    methods: {
        async getData(id) {
        this.id = id;
  
        try {
            var resp = await api.get(this, id);
            if (!resp.error) {
                this.dat = resp;
            }
            if(this.dat.Data.Data == null)
            {
              this.ExistenAprobaciones = false;
              return;
            }
            this.StrHtml = this.dat.Data.Data.html;
            this.VersionTDP = this.dat.Data.Inputs[0].VersionTDP;
            this.VersionTyC = this.dat.Data.Inputs[0].VersionTyC;
            if(this.VersionTDP == 0){
              this.VisibleTDP = false
            }
            if(this.VersionTyC == 0){
              this.VisibleTyC = false
            }
        } catch (e) {
            this.$alert("Ocurrió un error al intentar consultar tu link");
        } finally {
          this.loading = false;
        }
        return true;
        }, 
        async submit() {
              this.loading = true;  
              try {
                  let respuesta = await api.post(this, this.id);
                  this.$notificacion(respuesta.data).then(() => {
                      this.loading = true;
                      document.location = this.dat.FileName;
                  });
              } catch (e) {
                  this.$alert(
                      "Ocurrió un error al aprobar los documentos "
                  ).then(() => {
                      document.location = window.location.protocol + "//" + window.location.host + "/index.html#/";
                  });
              } finally {
                  this.loading = false;
              }
        },
        async descargarArchivo(IdVersion){
          try {
            const response = await api.downloadVersion(this, IdVersion);
            const documento = response["<ContenidoArchivo>k__BackingField"]
            const url = `data:application/pdf;base64,${documento}`;
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", response["<NombreArchivo>k__BackingField"]);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } catch (e) {
            this.$alert(
                "Ocurrió un error al descargar el archivo "
            ).then(() => {
                document.location = window.location.protocol + "//" + window.location.host + "/index.html#/";
            });
          }
        }
    }
  };
  </script>
  
  <style>
  
  form {
    margin: 1em auto;
  }
  
      form .form-footer {
          width: 100%;
          height: 20em !important;
          box-sizing: border-box;
          float: left;
          margin-bottom: 10px;
      }
  
  form .form-item {
    width: 100%;
    box-sizing: border-box;
    float: left;
    margin: 1em auto;
  }
  
  form label {
    display: block;
    padding: 0.5em 0;
    color: #777;
  }
  
  form input[type=text], form input[type=number], form input[type=email], form textarea {
    outline: none;
    text-align: center;
    border-width: 0px 0px 1px;
    border-top-style: initial;
    border-right-style: initial;
    border-bottom-style: solid;
    border-left-style: initial;
    border-top-color: initial;
    border-right-color: initial;
    border-bottom-color: rgb(204, 204, 204);
    border-left-color: initial;
    border-image: initial;
    background-color: white;
    font: inherit;
    display: block;
    width: 20em;
    box-sizing: border-box;
    color: #777;
    font-weight: 600;
    margin: auto;
  }
  
  .form-footer {
    margin-top: 1.5em;
  }
  
  @media screen and (max-width: 320px) {
    form input[type=text], form input[type=number], form input[type=email] {
      width: 18em;
    }
  }
  </style>
  